module.exports = __webpack_public_path__ + "static/img/uva.97a30f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/uva.png
// module id = 1HQn
// module chunks = 0